import React from 'react';
import styled from '@emotion/styled';
export const StyledInput = styled.input `
	opacity: 0;
	position: absolute;
	pointer-events: none;
	display: none;
`;
export const FileInput = ({ element, acceptedMimeTypes, multiple, onSelected, disabled, captureMode, id = 'file-input-button' }) => {
    let inputElement;
    const onChange = (event) => {
        if (!disabled && event.target.files && event.target.files.length > 0) {
            onSelected(event.target.files);
            /* istanbul ignore next */
            if (inputElement) {
                inputElement.value = '';
            }
        }
        event.preventDefault();
    };
    /* istanbul ignore next */
    const handleClick = () => {
        if (inputElement) {
            inputElement.click();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledInput, { id: id, type: "file", accept: acceptedMimeTypes, capture: captureMode ? captureMode : false, multiple: multiple, onChange: onChange, disabled: disabled, ref: input => (inputElement = input) }),
        React.createElement("span", { onClick: handleClick }, element)));
};
//# sourceMappingURL=FileInput.js.map